import axios, {AxiosError} from 'axios';

export const BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://app.mingava.se';
export const MainApi = "api";

const HEADERS = {
  "Authorization": "Authorization",
  "ContentType": "Content-Type",
  "ApplicationJson": "application/json"
};

export const ENDPOINTS = {
  ADMIN_FEE: "adminfee",
  CERTIFICATE: "certificate",
  CODE: "code",
  COOKIES: "cookies",
  DOCUMENT: "document",
  DONATION: "donation",
  DONATION_CAUSES: "donationcauses",
  DONATION_TYPES: "donationtypes",
  DONATIONS: "donations",
  ERROR: "error",
  FINALIZE: "finalize",
  IMAGE_CATEGORIES: "image-categories",
  IMAGES: "images",
  INVOICE: "invoice",
  LATEST: "latest",
  OPERATIONS: "operations",
  PAY_REQUEST: "payrequest",
  PAYMENT_METHODS: "paymentmethods",
  PAYMENTS: "payments",
  PRINT: "print",
  RECIPIENTS: "recipients",
  SEARCH: "search",
  SEND: "send",
  SERIALNUMBER: "serialnumber",
  SESSIONS_COOKIE_REQUEST: "sessions/cookie/request",
  SESSIONS_REQUEST: "sessions/request",
  SMS: "sms",
  SPAR_SERVICE: "service/spar",
  STATUS: "status",
  SYSTEM_STATUS: "system/status",
  SYSTEM_BANNERS: "system/banners",
  TOKEN: "token",
  TRANSACTIONS: "transactions",
  TRANSLATIONS: "translations",
  AS_JSON: "asjson",
};

export const ERROR_PAGE_URL = BASE_URL + "/" + ENDPOINTS.ERROR;


/**
 * Generic get request. Normally this should be preferred to more specific requests.
 * @param endpoint
 * @param params
 * @returns {Promise<AxiosResponse<T> | never>}
 */
export async function get(endpoint: string, params?: object, doHandleError= true) {

  return (
    await axios.get(BASE_URL + "/" + MainApi + "/" + endpoint,  {
        withCredentials: true,
        params
      })
      .then(response => response.data)
      .catch((error) => {
        if(doHandleError) {
          handleError(error)
        }
      })
      .finally(() => {

      })
  )
}

/**
 * Generic delete request. Normally this should be preferred to more specific requests.
 * @param endpoint
 * @param params
 * @returns {Promise<AxiosResponse<T> | never>}
 */
export async function deleteRequest(endpoint: string, params?: object) {
  return (
    await axios
      .delete(BASE_URL + "/" + MainApi + "/" + endpoint, {
        withCredentials: true,
        params
      })
      .then(response => response.data)
      .catch((error) => {
        handleError(error)
      })
      .finally(() => {

      })
  );
}

/**
 *
 * @param endpoint
 * @param params
 * @returns {Promise<any>}
 */
export async function post(endpoint: string, params: object) {
  return (
    await axios
      .post(BASE_URL + "/" + MainApi + "/" + endpoint, params, {
        withCredentials: true,
      })
      .then(response => response.data)
      .catch((error) => {
        handleError(error)
      })
      .finally(() => {

      })
  );
}

export function getFromSpar(ssn: string) {
  return axios
    .get(BASE_URL + "/" + ENDPOINTS.SPAR_SERVICE + "/" + ssn, {
      withCredentials: true
    })
    .then(response => response.data);
}

export function deleteCookie(cookieName: string) {
  return axios
    .delete(BASE_URL + '/api/cookies/' + cookieName, {
      withCredentials: true,
    })
    .then(response => response.data)
    .catch((error) => {
      handleError(error)
    })
    .finally(() => {

    })
}

export async function put(endpoint: string, params: object) {
  return (
    await axios
      .put(BASE_URL + "/" + MainApi + "/" + endpoint, params, {
        withCredentials: true,
      })
      .then(response => response.data)
      .catch((error) => {
        handleError(error)
      })
      .finally(() => {

      })
  );
}

function handleError(error: AxiosError) {
  if(error.response?.status === 401)
  {
    location.href = ERROR_PAGE_URL
  }
  throw error
}
